import { render } from "./App.vue?vue&type=template&id=37833eee"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37833eee&lang=less"

import exportComponent from "D:\\xmnengjia\\pc\\sim-pay3.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__